import { render, staticRenderFns } from "./AdminEditLab.vue?vue&type=template&id=8b3d645c&scoped=true&"
import script from "./AdminEditLab.vue?vue&type=script&lang=js&"
export * from "./AdminEditLab.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditLab.vue?vue&type=style&index=0&id=8b3d645c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3d645c",
  null
  
)

export default component.exports